import React, { useState } from 'react';
import styles from './HeaderComp.module.css';
import { Link, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import authService from '../services/authService';

const HeaderComp = () => {

    const location = useLocation();
    const { setSeller, setSellerAccount, getAccountFullName } = useAppContext();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const isActive = (path: string) => location.pathname === path;

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleLoginOut = () => {
        const logout = async () => {
            await authService.logout();
        }
        setSeller(null);
        setSellerAccount(null);
        logout();
    }

    return (
        <header className="pb-3 mb-3 border-bottom">
            <p className={`mb-3 p-2 text-center ${styles.consoleName}`}>TAHPI+ Seller Console</p>
            <div className="container">
                <div className="d-flex justify-content-between align-items-center">
                    <Link to="/"><img className={styles.logoImg} src="/images/tahpi-plus.png" alt="Logo" /></Link>
                    <button className={`btn d-lg-none ms-3 ${styles.collapsibleMenu}`} onClick={toggleMobileMenu}>
                        <i className="bi bi-list fs-2"></i>
                    </button>
                    <div className="d-none d-lg-flex align-items-center flex-grow-1 ms-4">
                        <div className={`${styles.menuNav} flex-grow-1`}>
                            <Link to="/" className={`${styles.menuItem} text-decoration-none ${isActive('/') ? styles.menuItemActive : ''}`}>Home</Link>
                            <Link to="/items" className={`${styles.menuItem} text-decoration-none ${isActive('/items') ? styles.menuItemActive : ''}`}>Items</Link>
                            <Link to="/offers" className={`${styles.menuItem} text-decoration-none ${isActive('/offers') ? styles.menuItemActive : ''}`}>Offers</Link>
                            <Link to="/customers" className={`${styles.menuItem} text-decoration-none ${isActive('/customers') ? styles.menuItemActive : ''}`}>Customers</Link>
                            <Link to="/messages" className={`${styles.menuItem} text-decoration-none ${isActive('/messages') ? styles.menuItemActive : ''}`}>Messages</Link>
                            <Link to="/billing" className={`${styles.menuItem} text-decoration-none ${isActive('/billing') ? styles.menuItemActive : ''}`}>Billing</Link>
                            <Link to="/storeSettings" className={`${styles.menuItem} text-decoration-none ${isActive('/storeSettings') ? styles.menuItemActive : ''}`}>Store Settings</Link>
                        </div>
                        <div className={`dropdown text-end ms-4 ${styles.menuProfileDropdown}`}>
                            <span className="link-body-emphasis text-decoration-none" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className={`bi bi-person-circle ${styles.menuProfileIcon}`}></i>
                                <div className={`d-lg-inline-block text-body-emphasis ${styles.menuProfileName}`}>{getAccountFullName()}</div>
                            </span>
                            <ul className="dropdown-menu dropdown-menu-end text-small rounded-0 mt-2">
                                <li><Link to="/myAccount" className='dropdown-item text-decoration-none'>My Account</Link></li>
                                <li><Link to="/changePassword" className='dropdown-item text-decoration-none'>Change Password</Link></li>
                                <li><div className="dropdown-divider"></div></li>
                                <li className="dropdown-item" onClick={handleLoginOut}>Sign Out</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {isMobileMenuOpen && (
                    <div className="d-lg-none mt-3">
                        <div className="list-group">
                            <Link to="/" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/') ? 'active' : ''}`}>Home</Link>
                            <Link to="/offers" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/offers') ? 'active' : ''}`}>Offers</Link>
                            <Link to="/items" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/items') ? 'active' : ''}`}>Items</Link>
                            <Link to="/customers" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/customers') ? 'active' : ''}`}>Customers</Link>
                            <Link to="/messages" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/messages') ? 'active' : ''}`}>Messages</Link>
                            <Link to="/billing" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/billing') ? 'active' : ''}`}>Billing</Link>
                            <Link to="/storeSettings" onClick={toggleMobileMenu} className={`list-group-item list-group-item-action ${isActive('/storeSettings') ? 'active' : ''}`}>Store Settings</Link>
                            <div className="border-top mt-5 pt-3 mb-3">
                                <div className="px-3 mt-2"><h5>{getAccountFullName()}</h5></div>
                                <Link to="/myAccount" onClick={toggleMobileMenu} className="list-group-item list-group-item-action">My Account</Link>
                                <Link to="/changePassword" onClick={toggleMobileMenu} className="list-group-item list-group-item-action">Change Password</Link>
                                <button className="list-group-item list-group-item-action text-start" onClick={handleLoginOut}>Sign Out</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default HeaderComp;
